<!-- https://www.smashingmagazine.com/2014/05/responsive-images-done-right-guide-picture-srcset/ -->
<template>
  <AdaptivePicture
    v-if="picture"
    :picture="picture"
    :width="width"
    :height="height"
    :srcset="srcSetPicture"
    :sizes="sizesPicture"
    :loading="loading"
    :decoding="decoding"
  />
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import type { TImage, TImageSize } from '~/types/common';
  import type { ImageSizesByDevice } from '@devhacker/shared/utils/image/types';
  import {
    getSrcSetByDPR,
    getSizesPicture,
    getImagesBySizes,
    getOriginImageFormat,
  } from '@devhacker/shared/utils/image';
  import AdaptivePicture from './AdaptivePicture.vue';

  export default defineNuxtComponent({
    name: 'AdaptivePictureArticlesCarouselSlide',

    components: {
      AdaptivePicture,
    },

    props: {
      picture: {
        type: Object as PropType<TImage | null>,
        required: true,
      },

      loading: {
        type: String as PropType<'lazy' | 'eager' | 'auto'>,
        default: undefined,
      },

      decoding: {
        type: String as PropType<'sync' | 'async' | 'auto'>,
        default: undefined,
      },
    },

    data: () => ({
      // размеры из нарезанных в 1x,
      // которые буду использоваться
      // https://www.figma.com/file/JGnLzMLGla9gSsvnW00NUY/Burning-Design-System-%F0%9F%94%A5?node-id=3138%3A136697&t=DS2oY88GzSsNdmHN-1
      articleCoverSizes: [232] as number[],
      sizesByDevice: {
        mobile: '128px',
        tablet: '128px',
      } as ImageSizesByDevice,
    }),

    computed: {
      sizes(): TImageSize[] {
        return this.picture?.sizes || [];
      },

      imagesBySizes(): TImageSize[] {
        return getImagesBySizes(this.articleCoverSizes, this.sizes);
      },

      imagesBySizesFirst(): TImageSize {
        const [firstImage] = this.imagesBySizes;

        return firstImage;
      },

      imageOrigin(): TImageSize {
        return getOriginImageFormat(this.picture?.origin);
      },

      width(): number {
        return this.imagesBySizesFirst.width || this.imageOrigin.width;
      },

      height(): number {
        return this.imagesBySizesFirst.height || this.imageOrigin.height;
      },

      srcSetPicture(): string {
        return getSrcSetByDPR(this.articleCoverSizes, this.sizes);
      },

      sizesPicture(): string {
        return getSizesPicture(this.sizesByDevice);
      },
    },

    methods: {},
  });
</script>

<style lang="scss" scoped>
  :deep() {
    // important из-за scss/article.scss
    // пересмотреть его: зачем там указывать сили для picture__img
    // если он есть в компоненте картиник и можно задать в обертке
    .picture__img {
      height: 100% !important;
      object-fit: cover !important;
    }
  }
</style>
